import { getLocale } from "../runtime";

const sv_gbcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Storbritannien`
};

const gbcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_gbcountry(inputs)
	return "gbCountry";
};

export { gbcountry as "gbCountry" };